// Breakpoints

export const SCREEN = {
  MOBILE_XS_BREAKPOINT: 480,
  MOBILE_SM_BREAKPOINT: 768,
  MOBILE_MD_BREAKPOINT: 900,
  MOBILE_LG_BREAKPOINT: 1200,
};
